module.exports = __webpack_public_path__ + "media/Video 108.0cf48dd3.mp4";